import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ContextProvider from "./context/";
import ReactDOM from "react-dom";
import React from "react";
import "./styles/site_management.css";
import "./styles/overrideDefaults.css";
import "./styles/index.css";
import "./styles/widgets.css";
import "./styles/tariffPayment.css";
import "./styles/theme.css";

import App from "./App";
import "remixicon/fonts/remixicon.css";
import "./i18n";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import { AuthContextProvider } from "./context/auth/auth_context";
// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./shared/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./shared/config";
import {
  DialogConsumer,
  DialogProvider,
} from "./components/event_transaction/components/shared/Dialog/DialogProvider";

const pca = new PublicClientApplication(msalConfig);

pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    pca.setActiveAccount(event.payload.account);
  }
});

// AuthContextProvider
const AppWithRouter = () => {
  return (
    <BrowserRouter>
      <AuthContextProvider>
        <DialogProvider>
          <DialogConsumer />
          {/* <ContextProvider> */}
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <MsalProvider instance={pca}>
              <App />
            </MsalProvider>
          </GoogleOAuthProvider>
          {/* </ContextProvider> */}
        </DialogProvider>
      </AuthContextProvider>
    </BrowserRouter>
  );
};

// <React.StrictMode>
{
  /* , */
}
ReactDOM.render(
  <React.StrictMode>
    <AppWithRouter />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
